import { Add } from '@mui/icons-material';
import { Avatar, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import * as React from 'react';
import Service from '../../../../util/Service';
const imgs = [
    "/svg/accordeon.svg",
    "/svg/azureIcon.svg",
    "/svg/choice.svg",
    "/svg/code.svg",
    "/svg/dialog.svg",
    "/svg/facebookIcon.svg",
    "/svg/find.svg",
    "/svg/form.svg",
    "/svg/googleIcon.svg",
    "/svg/input-field.svg",
    "/svg/layoutGrid.svg",
    "/svg/layoutPagina.svg",
    "/svg/listaUL.svg",
    "/svg/modeloPagina.svg",
    "/svg/mongoDB.svg",
    "/svg/query.svg",
    "/svg/rodape.svg",
    "/svg/tabela.svg",
]
export default function ActionFieldDialog(props) {
    const {refDiv, close, refresh } = props;
    const [open, setOpen] = React.useState(false);

    function handleOpenDialog() {
        setOpen(true);
    }
    function handleListItemClick(img) {
        console.log('--------');
        console.log(img);
        console.log('--------');

        Service.GET("/api/security/model/actionField").then(r => {
            console.log( r )
            if (r.success) {
                const div = document.createElement("div");
                let html = r.html;
                html = html.replace("IMG-TO-BE-CHANGED", img);
                div.innerHTML = html;
                const js = refDiv.current.querySelector("script");
                if( js ){
                    var jsOld =js.textContent;
                    if( !jsOld.includes('handlekeydownActionField')){
                        jsOld +="\n\n"+r.js 
                        js.textContent = jsOld;
                    }
                }else{
                    const s = document.createElement("script");
                    s.setAttribute('execute-react', true);
                    s.textContent = r.js;
                    refDiv.current.prepend(s);    
                }

                const st = refDiv.current.querySelector("style");
                if( st ){
                    var jsOld =st.textContent;
                    if( !jsOld.includes('input-wrapper ')){
                        jsOld +="\n\n"+r.css 
                        st.textContent = jsOld;
                    }
                    
                }else{
                    const s = document.createElement("style");
                    s.textContent = r.css;
                    refDiv.current.prepend(s);    
                }
                refDiv.current.appendChild(div);
                close();
                refresh();
            } else {
                alert(r.msg)
            }
        })
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <ListItem sx={{ cursor: 'pointer' }} onClick={handleOpenDialog} >
                <ListItemIcon>
                    <IconButton size="small">
                        <img width="24px" height="24px" src="/svg/input-field.svg" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Campo" secondary="Campo com ação" />
            </ListItem>

            <Dialog onClose={handleClose} open={open}>
                <DialogTitle>Escolha o icone</DialogTitle>
                <DialogContent>
                    <List component="nav" dense={true} sx={{
                        maxHeight: 300,
                        '& ul': { padding: 0 },
                    }}>
                        {imgs.map((row, id) => (
                            <ListItem key={id} disablePadding>
                                <ListItemButton
                                    autoFocus
                                    onClick={() => handleListItemClick(row)}
                                >
                                    <ListItemAvatar>
                                        <img width="24px" height="24px" src={row} />
                                    </ListItemAvatar>
                                    <ListItemText primary={row} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}